import React, { useEffect, useState } from "react";
import ProjectIcon from "../ProjectIcon/ProjectIcon";
import './ProjectsFolder.css';
import clinmetsImg from '../../images/clinmets.jpg'
import clinmetsIcon from '../../images/climentsLogo.png'
import bpicImg from '../../images/bpic.jpg'
import bpicIcon from '../../images/bpicLogo.png'
import pokeImg from '../../images/pokedex.jpg'
import pokeLogo from '../../images/colorPokeball.png'
import wordleImg from '../../images/wordle.jpg'
import wordleLogo from '../../images/wordleLogo.png'
import todoImg from '../../images/todoImg.jpg'
import todoLogo from '../../images/todoLogo.png'
import pongImg from '../../images/pongImg.jpg'
import pongLogo from '../../images/pongLogo.jpg'
import lalibertad from '../../images/lalibertad.jpeg'
import ProjectDetails from "../ProjectDetails/ProjectDetails";

const ProjectFolder = () =>{

    const [project, setProject] = useState()

    useEffect(()=>{
        console.log(project)
    },[project])

    const IconsNamesImgs = 
    [{name:"clinmets", icon:clinmetsIcon, img:clinmetsImg, description:"Página realizada para la clínica médica Clinmets", link:"http://clinmets.uy"},
    {name:"bpic", icon:bpicIcon, img:bpicImg, description:"Página realizada para la agencia de marketing Bpic", link:"https://agenciabpic.com"},
    {name:"la libertad", icon:lalibertad, img:lalibertad, description:"Trabajando en página web para la panadería La Libertad", link:""},
    {name:"wordle", icon:wordleLogo, img:wordleImg, description:"Proyecto personal, clon del juego wordle. Back-End y Front-End hecho por mí"},
    {name:"pokedex", icon:pokeLogo, img:pokeImg, description:"Proyecto final del bootcamp de Full Stack Web Developer, donde trabajé en equipo y utilizando metodologías ágiles para lograr el objetivo"},
    {name:"to do", icon:todoLogo, img:todoImg, description:"Proyecto realizado bootcamp de Full Stack Web Developer, donde trabajé en equipo y utilizando metodologías ágiles para lograr el objetivo"},
    {name:"pong", icon:pongLogo, img:pongImg, description:"Proyecto personal para indagar y experimentar en los videojuegos y programación orientada a objetos"}]

    return(
        <div className="projectsFolder">
            <ul className="projects">
                {
                    IconsNamesImgs.map(element => (
                        <li key={element.name}>
                            <ProjectIcon project={element} setProject={setProject}></ProjectIcon>
                        </li>
                    ))
                }
            </ul>
            <div className="buttonContainer">
                <button className="button">
                    <a href="https://github.com/NicoMarquez2" target="_blank">Git Hub</a>
                </button>
            </div>
            {project && 
                <ProjectDetails
                    project={project}
                    setProject={setProject}
                />
            }
        </div>
    )
}

export default ProjectFolder